import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PrivacyPolicy from '@/modules/settings/privacy-policy';
import WorkspaceSettings from '@/modules/settings/workspace-settings';
import MyProfileSettings from '@/modules/settings/user-settings';
import OrganisationSettings from '@/modules/settings/organisation-settings';
import { useAuthStore } from '@/store/auth';

type SettingsPageProps = {};

export default function SettingsPage({}: SettingsPageProps) {
  const context = useAuthStore((state) => state.context);
  const organisationId = useAuthStore((state) => state.user?.organisation?.id);
  const isWorkspace = context === 'workspace';
  const isOrganisation = context === 'organisation';

  return (
    <Tabs
      defaultValue='profile'
      className='relative h-full space-y-4 overflow-y-auto bg-white py-3'
    >
      <TabsList className='sticky left-0 right-0 top-0 w-full rounded-none border-b bg-white px-5'>
        <TabsTrigger value='profile'>My Account</TabsTrigger>
        {isWorkspace && (
          <TabsTrigger value='workspace'>Workspace Settings</TabsTrigger>
        )}
        {isOrganisation && (
          <TabsTrigger value='organisation'>Organisation Settings</TabsTrigger>
        )}
        {isWorkspace && (
          <TabsTrigger value='privacy-policy'>Workspace Privacy Policy</TabsTrigger>
        )}
      </TabsList>
      
      {/* User Profile Tab - Shows user settings with all account management */}
      <TabsContent value='profile' className='h-full w-full space-y-4'>
        <MyProfileSettings />
      </TabsContent>
      
      {/* Workspace Settings Tab - Only for workspace users */}
      {isWorkspace && (
        <TabsContent value='workspace' className='h-full space-y-4'>
          <WorkspaceSettings />
        </TabsContent>
      )}
      
      {/* Organisation Settings Tab - Only for organisation users */}
      {isOrganisation && (
        <TabsContent value='organisation' className='h-full space-y-4'>
          <OrganisationSettings organisationId={organisationId || ''} />
        </TabsContent>
      )}
      
      {/* Privacy Policy Tab - Only for workspace users */}
      {isWorkspace && (
        <TabsContent value='privacy-policy' className='h-full space-y-4'>
          <PrivacyPolicy />
        </TabsContent>
      )}
    </Tabs>
  );
}
